import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast, TextArea, Modal } from 'antd-mobile-v5';
import reporting_body from '../../static/images_ae/reporting/reporting_body.png';
import area_head from '../../static/images_ae/reporting/area_head.png';
import line_head from '../../static/images_ae/reporting/line_head.png';
import area_chest from '../../static/images_ae/reporting/area_chest.png';
import line_chest from '../../static/images_ae/reporting/line_chest.png';
import area_stomach from '../../static/images_ae/reporting/area_stomach.png';
import line_stomach from '../../static/images_ae/reporting/line_stomach.png';
import area_others from '../../static/images_ae/reporting/area_others.png';
import line_others from '../../static/images_ae/reporting/line_others.png';
import line_heart from '../../static/images_ae/reporting/line_heart.png';
import line_lungs from '../../static/images_ae/reporting/line_lungs.png';
import area_four_limbs from '../../static/images_ae/reporting/area_four_limbs.png';
import line_four_limbs from '../../static/images_ae/reporting/line_four_limbs.png';
import tip_top_select from '../../static/images_ae/reporting/tip_top_select.png';
import sympton_bg from '../../static/images_ae/reporting/sympton_bg.png';
import bg_back from '../../static/images_ae/reporting/bg_back.png';
import bg_finish_go_on from '../../static/images_ae/reporting/bg_finish_go_on.png';
import tip_bottom_select from '../../static/images_ae/reporting/tip_bottom_select.png';
import blue_body from '../../static/images_ae/alkReport/blue_body.png';
import organ_liver from '../../static/images_ae/reporting/organ_liver.png';
import organ_belly from '../../static/images_ae/reporting/organ_belly.png';
import organ_kidney from '../../static/images_ae/reporting/organ_kidney.png';
import line_liver from '../../static/images_ae/reporting/line_liver.png';
import line_belly from '../../static/images_ae/reporting/line_belly.png';
import line_kidney from '../../static/images_ae/reporting/line_kidney.png';
import arrow_back from '../../static/images_ae/alkReport/arrow_back.png';
import body_organ_liver from '../../static/images_ae/alkReport/body_organ_liver.png';
import body_organ_stomach from '../../static/images_ae/alkReport/body_organ_stomach.png';
import line_to_liver from '../../static/images_ae/alkReport/line_to_liver.png';
import line_to_stomach from '../../static/images_ae/alkReport/line_to_stomach.png';
import organ_liver_blue from '../../static/images_ae/alkReport/organ_liver_blue.png';
import organ_liver_purple from '../../static/images_ae/alkReport/organ_liver_purple.png';
import organ_stomach_blue from '../../static/images_ae/alkReport/organ_stomach_blue.png';
import organ_stomach_purple from '../../static/images_ae/alkReport/organ_stomach_purple.png';

import { withRouter } from 'react-router-dom';
import styles from './stomach.module.scss';

const api = new ApiCore();

const organMap = {
    'liver': '肝脏',
    'kidney': '肾脏',
    'stomach': '肠胃',
}

const Chest = (props: any) => {

    const [list, setList] = useState<any>([]);
    const [headSelected, setHeadSelected] = useState<any>(false);
    const [chestSelected, setChestSelected] = useState<any>(false);
    const [stomachSelected, setStomachSelected] = useState<any>(false);
    const [othersSelected, setOthersSelected] = useState<any>(false);
    const [fourLimbsSelected, setFourLimbsSelected] = useState<any>(false);
    const [selectedCount, setSelectedCount] = useState<any>(0);
    const [organs, setOrgans] = useState<any>(props.organs || {});
    const [organList, setOrganList] = useState<any>([]);
    const [symptoms, setSymptoms] = useState<any>([]);
    const [activeOrgan, setActiveOrgan] = useState<any>('liver');
    const [value, setValue] = useState<any>('');
    const [visible, setVisible] = useState<any>(false);
    const [headSelectedCount, setHeadSelectedCount] = useState<any>(0);
    const [chestSelectedCount, setChestSelectedCount] = useState<any>(0);
    const [stomachSelectedCount, setStomachSelectedCount] = useState<any>(0);

    useEffect(() => {
        window.document.title = 'ALK风险评估';
        initData();
        return () => {
            window.removeEventListener('popstate', onPopState);
        }
    }, [])

    useEffect(() => {
        let _selectedCount = 0;
        [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected].forEach((val: any) => {
            if (val) {
                _selectedCount++;
            }
        })
        setSelectedCount(_selectedCount);
    }, [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected])

    const initData = () => {
        window.addEventListener('popstate', onPopState)
        let _organs = props.organs;
        _organs.organs = _organs.organs.map((vvv: any) => {
            // if (vvv.type === 'lung') {
            //     setBrainIntro(vvv.remark);
            // } else if (vvv.type === 'heart') {
            //     setEyeIntro(vvv.remark);
            // }
            const _lastItem = vvv.symptoms[vvv.symptoms.length -1] || {};
            if (_lastItem && _lastItem.code === '') {
                return vvv;
            } else {
                const symptoms = vvv.symptoms.concat({
                    code: '',
                    name: '其他',
                    organCode: vvv.code
                })
                return {
                    ...vvv,
                    symptoms
                }
            }

        })
        setOrgans(_organs);
        let _list = organs.organs || []
        if (_list) {
            setOrganList(_list);
        }
        // 还原选中状态
        setOrganSelectedActive(_list);
    }

    const headSelect = () => {
        // setHeadSelected(!headSelected);
        // setChestSelected(false);
        // setStomachSelect(false);
        setActiveOrgan('liver');
        setHeadSelected(true);
        setStomachSelected(false);
    }

    const chestSelect = () => {

        // setChestSelected(!chestSelected);
        // setHeadSelected(false);
        // setStomachSelect(false);
        setActiveOrgan('kidney');
    }

    const stomachSelect = () => {
        setHeadSelected(false);
        setStomachSelected(true);
        // setStomachSelect(!stomachSelected);
        // setChestSelected(false);
        // setHeadSelected(false);
        setActiveOrgan('stomach');
    }

    const othersSelect = () => {
        setOthersSelected(!othersSelected);
    }

    const fourLimbsSelect = () => {
        setFourLimbsSelected(!fourLimbsSelected);
    }


    const symptomsSelected = (val: any, key: number) => {
        if (!val.code) {
            // 其他选项输入
            organList.some((val: any, key: number) => {
                if (activeOrgan === val.type) {
                    const _lastItem = val.symptoms[val.symptoms.length -1] || {};
                    if (_lastItem && _lastItem.code === '') {
                        setValue(_lastItem.value || '');
                        return true;
                    }
                }
            })
            setVisible(true);
            return;
        }
        let _heartCount = 0;
        let _lungCount = 0;
        let _stomachCount = 0;
        // const organMap = {
        //     'liver': '肝脏',
        //     'kidney': '肾脏',
        //     'stomach': '肠胃',
        // }
        const _list = organList.map((item: any) => {
            let _symptoms: any = item.symptoms.map((v: any) => {
                let _selected = !!v.selected;
                if (val.code === v.code) {
                    _selected = !v.selected;
                }
                if (item.type === 'liver') {
                    // 输入其他时
                    if (!v.code) {
                        if (v.value) {
                            _selected = true;
                        } else {
                            _selected = false;
                        }
                    }
                    if (_selected) {
                        _heartCount++;
                    }
                } else if (item.type === 'kidney') {
                    // 输入其他时
                    if (!v.code) {
                        if (v.value) {
                            _selected = true;
                        } else {
                            _selected = false;
                        }
                    }
                    if (_selected) {
                        _lungCount++;
                    }
                }else if (item.type === 'stomach') {
                    // 输入其他时
                    if (!v.code) {
                        if (v.value) {
                            _selected = true;
                        } else {
                            _selected = false;
                        }
                    }
                    if (_selected) {
                        _stomachCount++;
                    }
                }
                return {
                    ...v,
                    selected: _selected
                }
            });
            return {
                ...item,
                symptoms: _symptoms
            }
            // let selected = !!item.selected;
            // if (val.code === item.code) {
            //     selected = true;
            // }
            // return {
            //     selected: selected,
            //     ...item
            // }
        });
        setHeadSelected(_heartCount > 0);
        setChestSelected(_lungCount > 0);
        setStomachSelected(_stomachCount > 0);
        setHeadSelectedCount(_heartCount);
        setChestSelectedCount(_lungCount);
        setStomachSelectedCount(_stomachCount);
        setOrganList(_list);
        const _organs = organs;
        _organs.organs = _list;
        setOrgans(_organs)
        props.onComplete('abdomen', _list);
    }
    
    const setOrganSelectedActive = (mOrganList?: any) => {
        let _heartCount = 0;
        let _lungCount = 0;
        let _stomachCount = 0;
        // const organMap = {
        //     'liver': '肝脏',
        //     'kidney': '肾脏',
        //     'stomach': '肠胃',
        // }
        let _organList = mOrganList || organList;
        _organList.forEach((item: any) => {
            item.symptoms.forEach((v: any) => {
                let _selected = v.selected;
                if (item.type === 'liver') {
                    if (_selected) {
                        _heartCount++;
                    }
                } else if (item.type === 'kidney') {
                    if (_selected) {
                        _lungCount++;
                    }
                } else if (item.type === 'stomach') {
                    if (_selected) {
                        _stomachCount++;
                    }
                }
            });
        });
        setHeadSelected(_heartCount > 0);
        setChestSelected(_lungCount > 0);
        setStomachSelected(_stomachCount > 0);
        setHeadSelectedCount(_heartCount);
        setChestSelectedCount(_lungCount);
        setStomachSelectedCount(_stomachCount);
    }

    const setOtherValue = (value: any) => {
        let _organs = organs;
        _organs.organs = _organs.organs.map((vvv: any) => {
            const _lastItem = vvv.symptoms[vvv.symptoms.length -1] || {};
            if (_lastItem && _lastItem.code === '') {
                const symptoms = vvv.symptoms.map((vv: any) => {
                    if (activeOrgan === vvv.type && vv.code === '') {
                        let selected = !!value;
                        return {
                            code: '',
                            name: '其他',
                            value: value,
                            selected: selected,
                            organCode: vv.organCode
                        }
                    } else {
                        return vv;
                    }

                })
                return {
                    ...vvv,
                    symptoms
                }
            } else {
                return vvv;
            }

        })
        setOrgans(_organs)
        let _list = _organs.organs || []
        if (_list) {
            setOrganList(_list);
        }
        props.onComplete('abdomen', _list);
        return _list;
    }

    const onPopState = (event: any) => {
        props.onBack();
    }

    return (
        <div className={styles.ae_reporting}>
            {/* <div className={styles.tip_top_wrap}>
                <img className={styles.tip_top} src={tip_top_select} alt="" />
                <div className={styles.tip_top_text}>请从下列5个部位中选择您出现不适的部位</div>
            </div> */}
            <div className={styles.choose_symptom}>
                <div className={styles.content_area}>
                    <div className={styles.sympton_title}>ALK【腹部】常见风险症状：</div>
                    <div className={styles.sympton_content}>
                        {
                            organList.map((val: any, key: number) => {
                                if (activeOrgan === val.type) {
                                    return val.symptoms.map((val: any, iKey: number) => (
                                        <div key={iKey} className={`${val.selected ? styles.active : styles.un_active}`} onClick={() => { symptomsSelected(val, key) }}>{val.name}</div>
                                    ))
                                }
                            })
                        }
                    </div>
                </div>
            </div>
            <div className={styles.body_title}>
                <div className={styles.body_active}>
                    全部
                </div>
                <div className={styles.body_un_active}>
                    腹部
                </div>
                <div className={styles.body_un_active}>{ organMap[activeOrgan] || '未选器官'}</div>
            </div>
            <div className={styles.area_body_container}>
                <img className={styles.area_body} src={blue_body} alt="" />
                <img className={styles.area_body_organ_liver} src={body_organ_liver} alt="" />
                <img className={styles.area_body_organ_stomach} src={body_organ_stomach} alt="" />
                <div className={`${styles.area_base} ${styles.area_head} ${headSelected ? styles.area_active : styles.area_in_active}`} onClick={ () => { headSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>

                    <div className={styles.area_head_top}>
                        <img className={styles.icon_liver} src={headSelected ? organ_liver_blue : organ_liver_purple} alt="" />
                        <div>肝脏</div>
                        {
                            headSelectedCount > 0 &&
                            <div className={styles.symptom}>
                                {headSelectedCount}
                                <div className={`${styles.area_tr_r}`}></div>
                                <div className={`${styles.area_tr_t}`}></div>
                            </div>
                        }
                    </div>
                    {/* <div className={styles.area_head_middle}>
                    </div>
                    <div className={styles.area_head_bottom}>
                        包括精神方面、五官等部位
                    </div> */}
                    <img  className={styles.line_head} src={line_to_liver} alt="" />
                </div>
                {/* <div className={`${styles.area_base} ${styles.area_chest} ${chestSelected ? styles.area_active : ''}`} onClick={ () => { chestSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    {
                        chestSelectedCount > 0 &&
                        <div className={styles.ltSelectedCount}>
                            {chestSelectedCount}
                        </div>
                    }
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_head} src={organ_kidney} alt="" />
                        <div>肾脏</div>
                        {
                            chestSelectedCount > 0 &&
                            <div className={styles.symptom}>
                                {chestSelectedCount}
                                <div className={`${styles.area_tr_r}`}></div>
                                <div className={`${styles.area_tr_t}`}></div>
                            </div>
                        }
                    </div>
                    <img  className={styles.line_chest} src={line_kidney} alt="" />
                </div> */}
                <div className={`${styles.area_base} ${styles.area_others} ${stomachSelected ? styles.area_active : styles.area_in_active}`} onClick={ () => { stomachSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    {/* {
                        stomachSelectedCount > 0 &&
                        <div className={styles.ltSelectedCount}>
                            {stomachSelectedCount}个症状
                        </div>
                    } */}
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_stomach} src={stomachSelected ? organ_stomach_blue : organ_stomach_purple} alt="" />
                        <div>肠胃</div>
                        {
                            stomachSelectedCount > 0 &&
                            <div className={styles.symptom}>
                                {stomachSelectedCount}
                                <div className={`${styles.area_tr_r}`}></div>
                                <div className={`${styles.area_tr_t}`}></div>
                            </div>
                        }
                    </div>
                    {/* <div className={styles.area_head_middle}>
                    </div>
                    <div className={styles.area_head_bottom}>
                        包括心脏、肺部等器官
                    </div> */}
                    <img  className={styles.line_others} src={line_to_stomach} alt="" />
                </div>
                <div onClick={() => { props.onBack() }} className={`${styles.area_base} ${styles.area_four_limbs} ${fourLimbsSelected ? styles.area_active : styles.area_in_active}`}>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_stomach} src={arrow_back} alt="" />
                        <div>返回</div>
                    </div>
                </div>
            </div>
            {/* <div className={styles.sympton_select}>
                <div className={styles.sympton_select_img_wrap}>
                    <img src={sympton_bg} alt="" />
                </div>
                <div className={styles.sympton_select_text_wrap}>
                    <div className={styles.sympton_select_text}>请选择一个或多个与您症状贴近的病症描述：</div>
                    <div className={styles.sympton_select_menu}>
                        {
                            organList.map((val: any, key: number) => {
                                if (activeOrgan === val.type) {
                                    return val.symptoms.map((val: any, iKey: number) => (
                                        <div key={iKey} className={`${val.selected ? styles.menu_active : ''}`} onClick={() => { symptomsSelected(val, key) }}>{val.name}</div>
                                    ))
                                }
                            })
                        }
                    </div>
                </div>
            </div> */}
            {/* <div className={styles.btns_wrap}>
                <div className={styles.btns_back}>
                    <img className={styles.bootom_top} src={bg_back} alt="" />
                    <div className={styles.text} onClick={() => { props.onBack() }}>返回上一步</div>
                </div>
                <div className={styles.btns_finish_go_on}>
                    <img className={styles.bootom_top} src={bg_finish_go_on} alt="" />
                    <div className={styles.text} onClick={() => { props.onComplete('abdomen', organList) }}>选择完成，继续评测</div>
                </div>
            </div> */}
            <Modal
                visible={visible}
                content={
                    <TextArea
                        placeholder='请输入内容'
                        value={value}
                        onChange={val => {
                            setValue(val)
                        }}
                    />
                }
                closeOnAction
                onClose={() => {
                    setOrganSelectedActive(setOtherValue(value));
                    setVisible(false)
                }}
                actions={[
                    {
                        key: 'confirm',
                        text: '确定',
                    },
                ]}
            >
            </Modal>
        </div>
    )
}

export default withRouter(Chest);